import PropTypes from "prop-types";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import { Box, Button, Typography } from "@mui/material";
import CompanyTemplateDialog from "../../../../components/Administration/Organization/OrganizationDetails/CompanyTemplateDialog";

const ui = {
  pageBg: "#f7f8fa",
  panel: "#ffffff",
  railBg: "#ffffff",
  border: "#e6e9ee",
  borderStrong: "#d9dee7",
  text: "#182230",
  muted: "#667085",
  subtle: "#98a2b3",
  soft: "#f8fafc",
  successBg: "#eefaf2",
  successBorder: "#b7e4c4",
  successText: "#17733b",
};

const labelSx = {
  display: "block",
  mb: 0.45,
  color: ui.muted,
  fontSize: 11.2,
  lineHeight: 1.25,
  fontWeight: 650,
};

const OrganizationTemplate = ({
  companyId,
  disabled,
  onImported,
}) => {
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);

  return (
    <>
      <Box sx={{ mt: 1.35 }}>
        <Typography sx={labelSx}>
          <FormattedMessage id="admin.organizationDetails.companyTemplate" />
        </Typography>
        <Button
          fullWidth
          variant="outlined"
          size="small"
          startIcon={<UploadFileOutlinedIcon sx={{ fontSize: 14 }} />}
          disabled={disabled || !companyId}
          onClick={() => setTemplateDialogOpen(true)}
          sx={{
            minHeight: { xs: 40, sm: 36 },
            justifyContent: "flex-start",
            px: 1.05,
            borderRadius: 0.75,
            borderColor: ui.borderStrong,
            color: ui.text,
            textTransform: "none",
            fontSize: 11.7,
            fontWeight: 650,
            "&:hover": {
              borderColor: "#c5ccd6",
              bgcolor: ui.soft,
            },
          }}
        >
          <FormattedMessage id="admin.companyTemplateImport" />
        </Button>
        <Typography sx={{ mt: 0.45, color: ui.muted, fontSize: 10.55, lineHeight: 1.35 }}>
          <FormattedMessage id="admin.companyTemplateDescription" />
        </Typography>
      </Box>

      <CompanyTemplateDialog
        open={templateDialogOpen}
        onClose={() => setTemplateDialogOpen(false)}
        companyId={companyId}
        disabled={disabled}
        onImported={onImported}
      />
    </>
  );
};

OrganizationTemplate.propTypes = {
  companyId: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  onImported: PropTypes.func.isRequired,
};

OrganizationTemplate.defaultProps = {
  disabled: false,
};

OrganizationTemplate.displayName = "OrganizationTemplate";

export default OrganizationTemplate;
